<template>
  <div>
    <report-hero>
      <div class="selected-domain">
        <div class="back-to-domains" @click="backToDomains">
          <img src="@/assets/images/icons/arrow_orange_left.svg" alt="arrow left">
          Back to all domains
        </div>
        <div class="report">Your report for</div>
        <h3 class="title">{{ get_selected_domain?.Address }}</h3>
      </div>
    </report-hero>
    <performance-indicators />
    <accordion-reports />
    <start-free-trial class="hide-in-mobile"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { objectLength, sendReportDataLayer } from "@/utils";
import ReportHero from "@/components/report/2/Hero";
import PerformanceIndicators from "@/components/report/2/PerformanceIndicators";
import AccordionReports from "@/components/report/2/AccordionReports";
import StartFreeTrial from "@/components/global/StartFreeTrial";

export default {
  name: "SelectedDomain",
  components: {
    ReportHero,
    AccordionReports,
    StartFreeTrial,
    PerformanceIndicators,
  },
  mounted() {
    if (this.get_response && this.get_domains)
      this.sendEvent()
  },
  computed: {
    ...mapGetters(['get_selected_domain', 'get_domains', 'get_response'])
  },
  methods: {
    ...mapMutations(['SET_SELECTED_DOMAIN']),

    backToDomains() {
      this.SET_SELECTED_DOMAIN(null);
      this.sendReturnEvent();
      this.$router.push({ name: 'Report 2 Multiple Domains' })
    },

    sendReturnEvent() {
      sendReportDataLayer({
        report_step: 5.1,
        report_step_name: 'results_back',
      });
    },

    sendEvent() {
      const domains_count = objectLength( this.get_response?.ids ) + objectLength( this.get_response?.ineligibleIds ) + objectLength( this.get_response?.protectedIds );

      sendReportDataLayer({
        report_step: 5,
        report_step_name: "results",
        error: '', //TODO: add errors CC-3136
        domains_count,
        eligible_count: objectLength( this.get_response?.ids ),
        ineligible_count: objectLength( this.get_response?.ineligibleIds ),
        protected: objectLength( this.get_response?.protectedIds ),
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/responsive";
@import "src/assets/style/colors";

.selected-domain {
  .back-to-domains {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $orange;
    cursor: pointer;

    img {
      margin-right: 4px;
    }

    @include mobile{
      margin-top: 25px;
    }
  }
  .report {
    font-family: "Sofia Pro Light";
    font-size: 24px;
    color: $black;
    margin-top: 28px;

    @include mobile {
      font-size: 20px;
    }
  }
  .title {
    margin: 10px 0 28px 0;
    overflow:hidden;
    white-space:nowrap;
    text-overflow: ellipsis;

    @include mobile {
      font-size: 28px;
    }
  }
}
</style>